import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

type Props = {
	title: string;
	total: number;
	expanded: boolean;
};

export const ExpenseCategoryTitleLine: FC<Props> = ({
	title,
	total,
	expanded,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const ToggleIcon = expanded ? ChevronUp : ChevronDown;

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			gap={theme.spacingTokens.md}
		>
			<Typography variant="bodyMedium" noWrap>
				{title}
			</Typography>
			<Stack
				direction="row"
				alignItems="center"
				gap={theme.spacingTokens.sm}
				flexShrink={0}
			>
				<Typography
					variant="bodyMedium"
					color={total > 0 ? theme.palette.grey[700] : theme.palette.grey[400]}
					tabular
				>
					{moneyFormatter(total, t(Resources.Common.CurrencySign))}
				</Typography>
				<ToggleIcon size={theme.iconSize.sm} color={theme.palette.grey[400]} />
			</Stack>
		</Stack>
	);
};
